export const VOTE_COIN_COST = 1; // TODO: find a way to share constants with backend "functions" package
export const MIN_VOTES_TO_SHOW_SCORE_BUTTON = 5;

export const FAKE_PICTURE_ID = '_';

export enum Routes {
  play = '/play',
  score = '/score',
  auth = '/auth',
  landing = '/',
}
